<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-list">
    <vx-card ref="filterCard" title="Filters" class="user-list-filters mb-8">
      <div class="vx-row">
        <div
          class="vx-col md:w-1/3 sm:w-1/2 w-full"
          v-if="actor.privilege <= 2"
        >
          <label class="text-sm opacity-75">Branch</label>
          <v-select
            :options="branchList"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="filter.branch"
            class="mb-4 md:mb-0"
          />
        </div>
        <div
          class="vx-col md:w-1/3 sm:w-1/2 w-full"
          v-if="actor.privilege == 3"
        >
          <vs-input
            disabled
            label="Branch"
            class="w-full"
            :value="actor.ref_branch ? actor.ref_branch.name : '-'"
          />
        </div>
        <div class="vx-col md:w-1/3 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Privilege</label>
          <v-select
            :options="
              defaultPrivilegeList.filter((i) => {
                return i.value > actor.privilege
              })
            "
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="filter.privilege"
            class="mb-4 md:mb-0"
          />
        </div>
        <div class="vx-col md:w-1/3 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Type</label>
          <v-select
            :options="typeList"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="filter.type"
          />
        </div>
      </div>
    </vx-card>

    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <div class="flex-grow">
          <vs-button
            color="primary"
            type="gradient"
            class="mb-4 md:mb-0"
            @click="add"
            >Add New Data</vs-button
          >
        </div>

        <vs-dropdown vs-trigger-click class="cursor-pointer mr-2">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ page * per_page - (per_page - 1) }} -
              {{
                row_total - page * per_page > 0 ? page * per_page : row_total
              }}
              of {{ row_total }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="updatePerPage(10)">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(25)">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(50)">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(100)">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>

        <vs-input
          class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          v-model="keyword"
          @keyup="search"
          placeholder="Search..."
        />
      </div>
      <div class="table-container">
        <table class="table">
          <thead>
            <tr>
              <th>No</th>
              <th>Username</th>
              <th v-if="actor.privilege <= 3">Branch</th>
              <th v-if="actor.privilege <= 3">Sales</th>
              <th style="min-width: 120px">Full Name</th>
              <th>Phone</th>
              <th>Email</th>
              <th>Privilege</th>
              <th>Parent</th>
              <th>Last Login</th>
              <th>Type</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody v-if="loading">
            <tr>
              <td colspan="13" class="text-center">Loading....</td>
            </tr>
          </tbody>

          <tbody ref="tbody" v-else-if="data.length > 0">
            <tr v-for="(item, index) in data" :key="index">
              <td>{{ (page - 1) * per_page + (index + 1) }}</td>
              <td>
                <a
                  href="javascript:;"
                  @click="detail(item.id)"
                  :id="`detailBtn${item.id}`"
                  >{{ item.username }}</a
                >
              </td>
              <td v-if="actor.privilege <= 3">
                {{ item.ref_branch ? item.ref_branch.name : '' }}
              </td>
              <td v-if="actor.privilege <= 3">
                {{ item.ref_sales ? item.ref_sales.name : '' }}
              </td>
              <td>{{ item.full_name }}</td>
              <td>{{ item.phone }}</td>
              <td>{{ item.email }}</td>
              <td>
                {{
                  defaultPrivilegeList.find((i) => {
                    return i.value === item.privilege
                  }).label
                }}
              </td>
              <td>
                {{
                  item.parent
                    ? `${item.parent.full_name} (${item.parent.username})`
                    : '-'
                }}
              </td>
              <td>{{ item.last_login }}</td>
              <td>
                <vs-chip v-if="item.type !== 1">Basic</vs-chip>
                <vs-chip v-else color="success">Premium</vs-chip>
              </td>
              <td style="width: 90px">
                <div
                  v-if="item.privilege > actor.privilege"
                  class="flex centerx"
                >
                  <vx-tooltip text="Edit" position="top">
                    <vs-button
                      :id="`editBtn${item.portal_user_id}`"
                      type="border"
                      size="small"
                      icon-pack="feather"
                      icon="icon-edit"
                      color="success"
                      class="mr-2 vs-con-loading__container"
                      @click="edit(item.portal_user_id)"
                    ></vs-button>
                  </vx-tooltip>
                  <vx-tooltip text="Reset Password" position="top">
                    <vs-button
                      type="border"
                      size="small"
                      class="mr-2 vs-con-loading__container"
                      icon-pack="feather"
                      icon="icon-unlock"
                      color="primary"
                      @click="resetPassword(item.portal_user_id)"
                    ></vs-button>
                  </vx-tooltip>
                  <vx-tooltip
                    v-if="actor.privilege <= 2"
                    text="Change Permission"
                    position="top"
                  >
                    <vs-button
                      :id="`changePermissionBtn${item.id}`"
                      type="border"
                      size="small"
                      class="mr-2 vs-con-loading__container"
                      icon-pack="feather"
                      icon="icon-lock"
                      color="dark"
                      @click="changePermission(item.id)"
                    ></vs-button>
                  </vx-tooltip>
                  <vx-tooltip text="Delete" position="top">
                    <vs-button
                      type="border"
                      size="small"
                      icon-pack="feather"
                      icon="icon-trash"
                      color="danger"
                      @click="del(item.portal_user_id)"
                    ></vs-button>
                  </vx-tooltip>
                  <vx-tooltip
                    v-if="actor.privilege <= 3"
                    text="Generate Password"
                    position="top"
                  >
                    <!-- @click="generate_password(item, index)" -->
                    <vs-button
                      type="border"
                      class="ml-2 vs-con-loading__container"
                      size="small"
                      icon-pack="feather"
                      icon="icon-shield"
                      color="warning"
                      :id="`generateBtn_${index}`"
                      @click="
                        ;(activePromptGeneratePassword = true),
                          generate_password(item, index)
                      "
                    ></vs-button>
                  </vx-tooltip>
                </div>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="9" class="text-center">No Data Available</td>
            </tr>
          </tbody>
        </table>

        <vs-pagination :total="n_page" v-model="page" goto></vs-pagination>
      </div>

      <vs-popup
        classContent="popup-example"
        :title="popupTitle"
        :active.sync="showPopup"
      >
        <template>
          <div
            v-if="actor.privilege <= 3"
            class="vx-row mb-3"
            v-show="action !== 'reset_password'"
          >
            <div class="vx-col sm:w-1/2 w-full required">
              <label class="vs-input--label">Branch</label>
              <v-select
                :disabled="
                  action === 'detail' ||
                  (actor.privilege >= 2 && actor.sp_access != 1)
                "
                :options="branchList"
                :clearable="false"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="w-full"
                value="value"
                v-model="input.branch"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full required">
              <label class="vs-input--label">Parent</label>
              <v-select
                :disabled="action === 'detail'"
                @search="searchParent"
                :clearable="false"
                :options="parentList"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="w-full"
                v-model="input.parent"
              />
            </div>
          </div>
          <div class="vx-row mb-3" v-show="action !== 'reset_password'">
            <div class="vx-col sm:w-1/2 w-full required">
              <label class="vs-input--label">Privilege</label>
              <v-select
                :disabled="action === 'detail'"
                :options="privilegeList"
                :clearable="false"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="w-full"
                v-model="input.privilege"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full required">
              <label class="vs-input--label">Status</label>
              <v-select
                :disabled="action === 'detail'"
                :options="statusList"
                :clearable="false"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="w-full"
                v-model="input.status"
              />
            </div>
          </div>

          <div
            v-if="actor.privilege <= 3"
            class="vx-row mb-3"
            v-show="action !== 'reset_password'"
          >
            <div class="vx-col sm:w-1/2 w-full required">
              <label class="vs-input--label">Type Customer</label>
              <v-select
                :disabled="action === 'detail'"
                :options="typeCustomerList"
                :clearable="false"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="w-full"
                v-model="input.type_customer"
              />
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <label class="vs-input--label">Sales</label>
              <v-select
                :disabled="action === 'detail'"
                :clearable="false"
                :options="salesList"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="w-full"
                v-model="input.sales_id"
              />
            </div>
          </div>

          <div class="vx-row mb-3" v-show="action !== 'reset_password'">
            <div class="vx-col sm:w-1/2 w-full required">
              <vs-input
                :disabled="
                  action === 'detail' ||
                  (action === 'edit' && actor.privilege > 1)
                "
                label="Username"
                class="w-full"
                v-model="input.username"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full required">
              <label class="vs-input--label">Fullname</label>
              <table width="100%">
                <tr>
                  <td style="width: 20%">
                    <v-select
                      :disabled="action === 'detail'"
                      :clearable="false"
                      :options="prenameList"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="w-full"
                      v-model="input.prename"
                    />
                  </td>
                  <td>
                    <vs-input
                      :disabled="action === 'detail'"
                      class="w-full"
                      v-model="input.full_name"
                    />
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div
            v-show="action === 'add' || action === 'reset_password'"
            class="vx-row mb-3"
          >
            <div class="vx-col sm:w-1/2 w-full required">
              <table width="100%">
                <tr>
                  <td>
                    <vs-input
                      :disabled="action === 'detail'"
                      :type="textPassword"
                      label="Password"
                      class="w-full"
                      v-model="input.password"
                    />
                  </td>
                  <td>
                    <vs-button
                      style="margin-top: 22px; border: 1px solid #999999"
                      :color="'#FFFFFF'"
                      :text-color="'#999999'"
                      type="filled"
                      :icon="showPassword ? 'visibility' : 'visibility_off'"
                      @click="toggleShowPassword"
                    ></vs-button>
                  </td>
                </tr>
              </table>
            </div>
            <div class="vx-col sm:w-1/2 w-full required">
              <table width="100%">
                <tr>
                  <td>
                    <vs-input
                      :type="textPasswordConf"
                      label="Confirm Password"
                      class="w-full"
                      v-model="input.password1"
                    />
                  </td>
                  <td>
                    <vs-button
                      style="margin-top: 22px; border: 1px solid #999999"
                      :color="'#FFFFFF'"
                      :text-color="'#999999'"
                      type="filled"
                      :icon="showPasswordConf ? 'visibility' : 'visibility_off'"
                      @click="toggleShowPasswordConf"
                    ></vs-button>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div class="vx-row mb-3" v-show="action !== 'reset_password'">
            <div v-if="input.type_customer.value == 2" class="vx-col w-full">
              <label class="vs-input--label">Company Name</label>
              <table width="100%">
                <tr>
                  <td style="width: 20%">
                    <v-select
                      :disabled="action === 'detail'"
                      :clearable="false"
                      :options="prenameCoList"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="w-full"
                      v-model="input.prenameco"
                    />
                  </td>
                  <td>
                    <vs-input
                      :disabled="action === 'detail'"
                      class="w-full"
                      v-model="input.company_name"
                    />
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div class="vx-row mb-6" v-show="action !== 'reset_password'">
            <div class="vx-col sm:w-1/2 w-full required">
              <vs-input
                :disabled="action === 'detail'"
                label="Email"
                class="w-full"
                v-model="input.email"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full required">
              <vs-input
                :disabled="action === 'detail'"
                label="Phone"
                class="w-full"
                v-model="input.phone"
              />
            </div>
          </div>

          <div
            v-if="actor.privilege <= 3"
            class="vx-row mb-6"
            v-show="action !== 'reset_password'"
          >
            <div
              v-if="action == 'detail'"
              class="vx-col sm:w-1/2 w-full required"
            >
              <label class="vs-input--label">Type</label>
              <v-select
                :disabled="action === 'detail'"
                :options="typeList"
                :clearable="false"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="w-full"
                v-model="input.type"
              />
            </div>
          </div>
          <div class="vx-row mb-3" v-show="action !== 'reset_password'">
            <div class="vx-col w-full">
              <vs-textarea
                :disabled="action === 'detail'"
                label="Address"
                class="w-full"
                rows="3"
                v-model="input.address"
              />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full ml-auto">
              <vs-button
                v-if="action !== 'detail'"
                id="submitBtn"
                class="mr-3 mb-2 vs-con-loading__container"
                @click="submit"
                >Submit</vs-button
              >
              <vs-button
                v-show="action === 'add'"
                color="warning"
                type="border"
                @click="reset"
                class="mb-2"
                >Reset</vs-button
              >
            </div>
          </div>
        </template>
      </vs-popup>

      <vs-popup
        classContent="popup-example"
        :title="permissionPopupTitle"
        :active.sync="permissionPopup"
      >
        <template>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <label class="vs-input--label">Template</label>
              <v-select
                :options="templateList"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="w-full"
                v-model="permissionTemp"
              />
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 w-full">
              <label class="vs-input--label">Permission List</label>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/2 w-full">
              <ul class="mt-3">
                <li
                  v-for="(item, index) in menuList.slice(0, menuDividerIndex)"
                  :key="index"
                  class="mb-3"
                >
                  <vs-checkbox
                    v-model="input.permission"
                    @click="check(item)"
                    :vs-value="item.id"
                    :style="item.parent ? 'margin-left: 30px' : ''"
                    >{{ item.name }}</vs-checkbox
                  >
                </li>
              </ul>
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <ul class="mt-3">
                <li
                  v-for="(item, index) in menuList.slice(
                    menuDividerIndex,
                    menuList.length
                  )"
                  :key="index"
                  class="mb-3"
                >
                  <vs-checkbox
                    v-model="input.permission"
                    @click="check(item)"
                    :vs-value="item.id"
                    :style="item.parent ? 'margin-left: 30px' : ''"
                    >{{ item.name }}</vs-checkbox
                  >
                </li>
              </ul>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full ml-auto">
              <vs-button
                id="submitPermissionBtn"
                class="mr-3 mb-2 vs-con-loading__container"
                @click="submitPermission"
                >Submit</vs-button
              >
              <vs-button
                id="resetPermissionBtn"
                class="mr-3 mb-2 vs-con-loading__container"
                color="warning"
                @click="restoreDefault"
                >Restore to Default</vs-button
              >
            </div>
          </div>
        </template>
      </vs-popup>

      <vs-popup
        classContent="popup-example"
        :title="generatePopupTitle"
        :active.sync="generatePopup"
      >
        <template>
          <div class="vx-row mb-3">
            <div class="vx-col w-full mb-3">
              <label for="" style="font-weight: bold"
                >You can Copy Username and Password below to Login Web and Apps
                Tracking</label
              >
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-3">
              <table width="100%">
                <tr>
                  <td>
                    <vs-input
                      label="Username"
                      class="w-full"
                      :value="user_generate"
                      id="user_generate"
                    />
                  </td>
                  <td>
                    <vs-button
                      title="Copy Username"
                      style="margin-top: 22px; border: 1px solid #999999"
                      :color="'#FFFFFF'"
                      :text-color="'#999999'"
                      type="filled"
                      icon="content_copy"
                      @click="doCopyUsername"
                    ></vs-button>
                  </td>
                </tr>
              </table>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <table width="100%">
                <tr>
                  <td>
                    <vs-input
                      label="Generate Password"
                      class="w-full"
                      :value="pass_generate"
                      id="pass_generate"
                    />
                  </td>
                  <td>
                    <vs-button
                      title="Copy Generate Password"
                      style="margin-top: 22px; border: 1px solid #999999"
                      :color="'#FFFFFF'"
                      :text-color="'#999999'"
                      type="filled"
                      icon="content_copy"
                      @click="doCopyPassword"
                    ></vs-button>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </template>
      </vs-popup>
    </div>

    <vs-prompt
      title="Generate Password"
      color="warning"
      @accept="confirmGenerate"
      :active.sync="activePromptGeneratePassword"
    >
      <div class="con-exemple-prompt">
        <h6>Are you sure want to Generate Password this User ?</h6>

        <label class="text-sm opacity-75">Password Duration</label>
        <v-select
          :options="list_duration"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
          v-model="password_duration"
          class="mb-4 md:mb-0"
        />
      </div>
    </vs-prompt>
  </div>
</template>

<style>
.vs__selected-options {
  flex-wrap: nowrap;
}
</style>

<style lang="stylus">
.con-exemple-prompt
  padding 10px;
  padding-bottom 0px;
  .vs-input
    width 100%
    margin-top 10px;
</style>

<script>
import vSelect from 'vue-select'

export default {
  components: {
    vSelect
  },

  data() {
    return {
      actor: {},
      data: [],
      token: '',
      showPopup: false,
      popupTitle: '',
      action: '',
      loading: true,
      showPassword: false,
      showPasswordConf: false,
      textPassword: 'password',
      textPasswordConf: 'password',

      permissionPopup: false,
      permissionPopupTitle: '',

      menuList: [],
      menuDividerIndex: 0,

      tempId: 0,
      tempPrivilege: 4,

      defaultPrivilegeList: [
        { value: 2, label: 'Administrator' },
        { value: 3, label: 'Admin Cabang' },
        { value: 4, label: 'General User' },
        { value: 5, label: 'Dispatcher' },
        { value: 6, label: 'Limited User' }
      ],

      privilegeList: [],
      salesList: [],
      defaultTemplateList: [],
      templateList: [],
      permissionTemp: '',
      tempSales: '',

      branchList: [],
      parentList: [{ value: 0, label: '-- No Parent --' }],

      statusList: [
        { value: 1, label: 'Active' },
        { value: 0, label: 'Inactive' }
      ],

      typeList: [
        { value: 0, label: 'Basic' },
        { value: 1, label: 'Premium' }
      ],

      input: {
        username: '',
        full_name: '',
        password: '',
        password1: '',
        privilege: '',
        type: '',
        company_name: '',
        phone: '',
        email: '',
        address: '',
        branch: '',
        status: { value: 1, label: 'Active' },
        parent: { value: 0, label: '-- No Parent --' },
        permission: [],
        permissionTemp: '',
        app_user_id: '',
        prename: { value: 'MR', label: 'MR' },
        sales_id: '',
        type_customer: '',
        prenameco: ''
      },

      filter: {
        branch: '',
        privilege: '',
        type: ''
      },

      page: 1,
      per_page: 10,
      row_total: 0,
      keyword: '',

      timer: null,
      notify: 'Server Error',

      temp_branch: '',

      user_generate: '',
      user_generate_index: '',
      pass_generate: '',
      generatePopup: false,
      generatePopupTitle: '',

      prenameList: [
        {
          value: 'MR',
          label: 'MR'
        },
        {
          value: 'MRS',
          label: 'MRS'
        },
        {
          value: 'MS',
          label: 'MS'
        }
      ],

      typeCustomerList: [
        {
          value: 1,
          label: 'Individual'
        },
        {
          value: 2,
          label: 'Company'
        }
      ],

      prenameCoList: [
        {
          value: 'PT',
          label: 'PT'
        },
        {
          value: 'CV',
          label: 'CV'
        },
        {
          value: 'TBK',
          label: 'TBK'
        },
        {
          value: 'Corp',
          label: 'Corp'
        },
        {
          value: 'Inc',
          label: 'Inc'
        },
        {
          value: 'UD',
          label: 'UD'
        },
        {
          value: 'Ltd',
          label: 'Ltd'
        }
      ],

      client_ip: '',

      activePromptGeneratePassword: false,
      valGenerate: '',
      password_duration: { label: '1 Hour', value: 1 },
      list_duration: [
        { label: '1 Hour', value: 1 },
        { label: '2 Hour', value: 2 },
        { label: '3 Hour', value: 3 },
        { label: '4 Hour', value: 4 },
        { label: '5 Hour', value: 5 }
      ]
    }
  },

  computed: {
    n_page() {
      return Math.ceil(this.row_total / this.per_page)
    },

    branch() {
      return this.input.branch.value ? this.input.branch.value : 0
    },

    n_menu() {
      return this.menuList.length
    },

    parent() {
      return this.input.parent.value ? this.input.parent.value : 0
    }
  },

  watch: {
    page() {
      this.initTable()
    },

    per_page() {
      if (this.page != 1) this.page = 1
      else this.initTable()
    },

    branch() {
      this.getSalesList()
      if (this.input.branch.value != this.temp_branch) {
        this.input.parent = { value: 0, label: '-- No Parent --' }
        this.parentList = [{ value: 0, label: '-- No Parent --' }]
      }
    },

    n_menu() {
      this.menuList.map((item, index) => {
        if (
          index >= this.n_menu / 2 &&
          !item.parent &&
          this.menuDividerIndex == 0
        ) {
          this.menuDividerIndex = index
        }
      })
    },

    permissionTemp() {
      if (this.permissionTemp !== '') {
        // get detail
        this.$http
          .get(
            `${this.$api.endpoint}/permission_temp/detail/${this.permissionTemp.value}`,
            {
              headers: {
                Authorization: `Bearer ${this.token}`
              }
            }
          )
          .then((res) => {
            var data = res.data.message.data
            this.input.permission = data.permission
              ? JSON.parse(data.permission)
              : []
          })
      }
    },

    parent() {
      if (this.action == 'detail') return

      if (this.parent === 0) {
        // this.privilegeList = this.defaultPrivilegeList.filter((i) => {
        //   return i.value > this.actor.privilege
        // })
        // this.input.parent
      } else {
        this.$http
          .get(`${this.$api.endpoint}/user/detail/${this.parent}`, {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          })
          .then((res) => {
            const data = res.data.message.data
            // this.privilegeList = this.defaultPrivilegeList.filter((i) => {
            //   return i.value > data.privilege
            // })

            // this.input.privilege = this.privilegeList.find((i) => {
            //   return i.value === data.privilege + 1
            // })
          })
          .catch((error) => {
            this.$gf.httpErrorHandler(error)
          })
      }
    },

    filter: {
      handler(val) {
        this.initTable()
      },
      deep: true
    }
  },

  created() {
    this.token =
      localStorage.getItem('userInfo') !== null
        ? JSON.parse(localStorage.getItem('userInfo')).token
        : ''
    this.getBranchList()
    this.getPermissionTemp()
    this.getMenuList()

    this.$http
      .get(`${this.$api.endpoint}/user/profile`, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      })
      .then((res) => {
        this.actor = res.data.message.data

        this.privilegeList = this.defaultPrivilegeList.filter((i) => {
          return i.value > this.actor.privilege
        })

        this.input.privilege = this.defaultPrivilegeList.find((i) => {
          return i.value === this.actor.privilege + 1
        })
      })
      .catch((error) => {
        this.$gf.httpErrorHandler(error)
      })

    this.initTable()
  },

  mounted() {
    this.client_ip = JSON.parse(localStorage.getItem('client_ip'))
    this.getSalesList()
  },

  methods: {
    toggleShowPassword() {
      this.showPassword = !this.showPassword
      if (!this.showPassword) this.textPassword = 'password'
      else this.textPassword = 'text'
    },
    toggleShowPasswordConf() {
      this.showPasswordConf = !this.showPasswordConf
      if (!this.showPasswordConf) this.textPasswordConf = 'password'
      else this.textPasswordConf = 'text'
    },
    search() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.page = 1
        this.initTable()
      }, 800)
    },

    searchParent(search, loading) {
      if (this.input.branch && search.length >= 3) {
        this.$http
          .get(
            `${this.$api.endpoint}/user/parent/${this.branch}?search=${search}`,
            {
              headers: {
                Authorization: `Bearer ${this.token}`
              }
            }
          )
          .then((res) => {
            this.parentList = [{ value: 0, label: '-- No Parent --' }]
            res.data.message.data.map((item) => {
              if (item.value !== this.tempId) this.parentList.push(item)
            })
          })
          .catch((error) => {
            this.$gf.httpErrorHandler(error)
          })
      } else {
        this.parentList = []
      }
    },

    updatePerPage(n) {
      this.per_page = n
      this.initTable()
    },

    reset() {
      Object.keys(this.input).map((item) => {
        this.privilegeList = this.defaultPrivilegeList.filter((i) => {
          // if (this.actor.privilege === 3) {
          //   return i.value === this.actor.privilege + 1
          // } else {
          //   return i.value > this.actor.privilege
          // }

          return i.value > this.actor.privilege
        })

        if (item === 'status') this.input[item] = { value: 1, label: 'Active' }
        else if (item === 'privilege')
          this.input[item] = this.privilegeList.find((i) => {
            return (i.value = this.actor.privilege + 1)
          })
        else if (item === 'branch')
          this.input[item] = this.branchList.find((i) => {
            return i.value === this.actor.branch
          })
        else if (item === 'parent')
          this.input[item] = { value: 0, label: '-- No Parent --' }
        else if (item === 'prename')
          this.input[item] = { value: 'MR', label: 'MR' }
        else if (item === 'type')
          this.input[item] = { value: 0, label: 'Basic' }
        else if (item === 'type_customer')
          this.input[item] = { value: 1, label: 'Individual' }
        else if (item === 'prenameco')
          this.input[item] = {
            value: 'PT',
            label: 'PT'
          }
        else this.input[item] = ''
      })
    },

    getBranchList() {
      this.$http
        .get(`${this.$api.endpoint}/branch/select`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.branchList = res.data.message.data
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    getPermissionTemp() {
      this.$http
        .get(`${this.$api.endpoint}/permission_temp/select`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.defaultTemplateList = res.data.message.data
        })
    },

    getMenuList() {
      this.$http
        .get(`${this.$api.endpoint}/menu`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.menuList = res.data.message.data
        })
    },

    check(item) {
      if (item.parent) {
        if (this.input.permission.indexOf(item.parent.id) === -1)
          this.input.permission.push(item.parent.id)
      } else {
        this.menuList.map((i, index) => {
          if (i.parent) {
            if (i.parent.id === item.id) {
              if (this.input.permission.indexOf(i.id) !== -1)
                this.input.permission.splice(
                  this.input.permission.indexOf(i.id),
                  1
                )
            }
          }
        })
      }
    },

    initTable() {
      this.loading = true
      this.$http
        .get(`${this.$api.endpoint}/user/datatable`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          },
          params: {
            page: this.page,
            per_page: this.per_page,
            search: this.keyword,

            branch: this.filter.branch ? this.filter.branch.value : '',
            privilege: this.filter.privilege ? this.filter.privilege.value : '',
            type: this.filter.type ? this.filter.type.value : ''
          }
        })
        .then((res) => {
          this.row_total = res.data.message.total
          this.data = res.data.message.data
          this.loading = false
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    add() {
      if (this.action !== 'add') this.reset()
      this.action = 'add'
      this.popupTitle = 'Add User'

      this.input.branch = this.branchList.find((i) => {
        return i.value === this.actor.branch
      })
      this.showPopup = true
    },

    edit(id) {
      this.action = 'edit'
      this.popupTitle = 'Edit User'

      // this.privilegeList = this.defaultPrivilegeList.filter((i) => {
      //   return i.value > this.actor.privilege
      // })

      this.$vs.loading({
        background: 'success',
        color: '#fff',
        container: '#editBtn' + id,
        scale: 0.45
      })

      this.$http
        .get(`${this.$api.portal_host}/user/detail/${id}`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          },
          params: {
            sync: 'seen'
          }
        })
        .then((res) => {
          const data = res.data.message.data

          this.tempId = data.id
          this.temp_branch = data.branch.id
          this.$vs.loading.close(`#editBtn${id} > .con-vs-loading`)

          this.input.branch = this.branchList.find((item) => {
            return item.value === data.branch.id
          })

          // ========================================

          if (this.actor.privilege == 1) {
            this.privilegeList = this.defaultPrivilegeList.filter((i) => {
              return i.value > this.actor.privilege
            })
          } else {
            this.privilegeList = this.defaultPrivilegeList.filter((i) => {
              return i.value >= data.privilege
            })
          }

          // ========================================

          this.input.privilege = this.privilegeList.find((item) => {
            return item.value === data.privilege
          })

          this.input.status = this.statusList.find((item) => {
            return item.value === data.status
          })

          if (data.parent) {
            // this.privilegeList = this.defaultPrivilegeList.filter((i) => {
            //   return i.value > data.parent.privilege
            // })

            this.parentList = [
              { value: 0, label: '-- No Parent --' },
              { value: data.parent.id, label: data.parent.username }
            ]

            this.input.parent = {
              value: data.parent.id,
              label: data.parent.username
            }
          } else {
            this.parentList = [{ value: 0, label: '-- No Parent --' }]
            this.input.parent = { value: 0, label: '-- No Parent --' }
          }

          this.input.type = this.typeList.find((item) => {
            return item.value === data.type
          })

          if (data.prename) {
            this.input.prename = this.prenameList.find((item) => {
              return item.value === data.prename
            })
          } else {
            this.input.prename = { value: 'MR', label: 'MR' }
          }

          if (data.sales_id) {
            this.input.sales_id = this.salesList.find((item) => {
              return item.value === data.sales_id
            })
          } else {
            this.input.sales_id = { value: '', label: '' }
          }

          if (data.type_customer) {
            this.input.type_customer = this.typeCustomerList.find((item) => {
              return item.value === data.type_customer
            })
          } else {
            this.input.type_customer = { value: 1, label: 'Individual' }
          }

          if (data.prenameco && data.prenameco != '-') {
            this.input.prenameco = this.prenameCoList.find((item) => {
              return item.value === data.prenameco
            })
          } else {
            this.input.prenameco = {
              value: 'PT',
              label: 'PT'
            }
          }

          this.input.username = data.username
          this.input.company_name = data.company_name
          this.input.full_name = data.fullname
          this.input.company_name = data.company_name
          this.input.email = data.email
          this.input.phone = data.phone
          this.input.address = data.address

          this.input.app_user_id = data.app_user_id

          this.showPopup = true
        })
    },

    detail(id) {
      this.tempId = id
      this.action = 'detail'
      this.popupTitle = 'Detail User'

      this.privilegeList = this.defaultPrivilegeList.filter((i) => {
        return i.value > this.actor.privilege
      })

      this.$http
        .get(`${this.$api.endpoint}/user/detail/${id}`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          const data = res.data.message.data

          this.parentList = [{ value: 0, label: '-- No Parent --' }]

          if (data.parent) {
            this.privilegeList = this.defaultPrivilegeList.filter((i) => {
              return i.value > data.parent.privilege
            })
            this.parentList.push({
              value: data.parent.id,
              label: data.parent.username
            })
            this.input.parent = {
              value: data.parent.id,
              label: data.parent.username
            }
          } else {
            this.input.parent = { value: 0, label: '-- No Parent --' }
          }
          this.$vs.loading.close(`#editBtn${id} > .con-vs-loading`)

          this.input.branch = this.branchList.find((item) => {
            return item.value === data.branch
          })

          this.input.privilege = this.privilegeList.find((item) => {
            return item.value === data.privilege
          })

          this.input.type = this.typeList.find((item) => {
            return item.value === data.type
          })

          this.input.status = this.statusList.find((item) => {
            return item.value === data.status
          })

          if (data.prename) {
            this.input.prename = this.prenameList.find((item) => {
              return item.value === data.prename
            })
          } else {
            this.input.prename = { value: 'MR', label: 'MR' }
          }

          if (data.sales_id) {
            this.input.sales_id = this.salesList.find((item) => {
              return item.value === data.sales_id
            })
          } else {
            this.input.sales_id = { value: '', label: '' }
          }

          if (data.type_customer) {
            this.input.type_customer = this.typeCustomerList.find((item) => {
              return item.value === data.type_customer
            })
          } else {
            this.input.type_customer = { value: 1, label: 'Individual' }
          }

          if (data.prenameco && data.prenameco != '-') {
            this.input.prenameco = this.prenameCoList.find((item) => {
              return item.value === data.prenameco
            })
          } else {
            this.input.prenameco = {
              value: 'PT',
              label: 'PT'
            }
          }

          this.input.username = data.username
          this.input.company_name = data.company_name
          this.input.full_name = data.full_name
          this.input.email = data.email
          this.input.phone = data.phone
          this.input.address = data.address

          this.showPopup = true
        })
    },

    resetPassword(id) {
      this.tempId = id
      this.action = 'reset_password'
      this.popupTitle = 'Reset Password'

      this.showPopup = true
    },

    changePermission(id) {
      this.tempId = id
      this.action = 'change_permission'
      this.permissionPopupTitle = 'Change Permission'

      this.$vs.loading({
        background: 'dark',
        color: '#fff',
        container: '#changePermissionBtn' + id,
        scale: 0.45
      })

      this.$http
        .get(`${this.$api.endpoint}/user/detail/${id}`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.$vs.loading.close(`#changePermissionBtn${id} > .con-vs-loading`)
          var data = res.data.message.data
          this.templateList = this.defaultTemplateList.filter((item) => {
            return item.privilege === data.privilege
          })

          this.tempPrivilege = data.privilege

          this.input.permission = data.permission
            ? JSON.parse(data.permission)
            : []

          this.permissionPopup = true
        })
        .catch((error) => {
          this.$vs.loading.close(`#changePermissionBtn${id} > .con-vs-loading`)
        })
    },

    del(id) {
      this.tempId = id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Delete User`,
        text: 'Are you sure want to Delete this User ?',
        accept: this.confirmDelete
      })
    },

    confirmDelete() {
      this.$http
        .post(
          `${this.$api.portal_host}/user/delete/${this.tempId}`,
          {
            sync: 'seen',
            client_ip: this.client_ip
          },
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          // console.log(res)
          this.notify = res.data.message.split('_').join(' ')

          this.initTable()

          this.$vs.notify({
            title: 'Thank You',
            text: this.notify,
            color: 'success',
            position: 'top-right'
          })
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    submit() {
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: '#submitBtn',
        scale: 0.45
      })

      let url = ''
      if (this.action === 'add') url = `${this.$api.portal_host}/user/add`
      if (this.action === 'edit')
        url = `${this.$api.portal_host}/user/update/${this.tempId}`
      if (this.action === 'reset_password')
        url = `${this.$api.portal_host}/user/reset_password/${this.tempId}`

      this.$http
        .post(
          url,
          {
            branch_id:
              this.actor.privilege <= 2
                ? this.input.branch.value
                : this.actor.branch,
            parent:
              this.actor.privilege <= 3
                ? this.input.parent.value
                : this.actor.id,
            privilege: this.input.privilege.value,
            status: this.input.status.value,
            username: this.input.username,
            fullname: this.input.full_name,
            password: this.input.password,
            password_confirmation: this.input.password1,
            company_name: this.input.company_name,
            email: this.input.email,
            phone: this.input.phone,
            address: this.input.address,
            sync: 'seen',
            app_user_id: this.input.app_user_id,
            prename: this.input.prename ? this.input.prename.value : '',
            sales_id: this.input.sales_id ? this.input.sales_id.value : '',
            type_customer: this.input.type_customer.value,
            prenameco:
              this.input.type_customer.value == 2
                ? this.input.prenameco.value
                : '-',
            client_ip: this.client_ip
          },
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.$vs.loading.close('#submitBtn > .con-vs-loading')

          this.notify = res.data.message.split('_').join(' ')

          this.showPopup = false
          this.initTable()
          this.reset()

          this.$vs.notify({
            title: 'Thank You',
            text: this.notify,
            color: 'success',
            position: 'top-right'
          })
        })
        .catch((error) => {
          this.$vs.loading.close('#submitBtn > .con-vs-loading')
          this.$gf.httpErrorHandler(error)
        })
    },

    restoreDefault(id) {
      this.tempId = id
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: `Restore to Default`,
        text: 'Are you sure want to Permission to Default?',
        accept: this.confirmRestore
      })
    },

    confirmRestore() {
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: '#resetPermissionBtn',
        scale: 0.45
      })

      this.$http
        .get(
          `${this.$api.endpoint}/permission_temp/default/${this.tempPrivilege}`,
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.$vs.loading.close(`#resetPermissionBtn > .con-vs-loading`)

          const data = res.data.message.data
          this.input.permission = data.permission
            ? JSON.parse(data.permission)
            : []
        })
        .catch((error) => {
          this.$vs.loading.close(`#resetPermissionBtn > .con-vs-loading`)
          this.$gf.httpErrorHandler(error)
        })
    },

    submitPermission() {
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: '#submitPermissionBtn',
        scale: 0.45
      })

      this.$http
        .post(
          `${this.$api.endpoint}/user/change_permission/${this.tempId}`,
          {
            permission: JSON.stringify(this.input.permission)
          },
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.$vs.loading.close(`#submitPermissionBtn > .con-vs-loading`)
          this.notify = res.data.message.split('_').join(' ')

          this.permissionPopup = false

          this.$vs.notify({
            title: 'Thank You',
            text: this.notify,
            color: 'success',
            position: 'top-right'
          })
        })
        .catch((error) => {
          this.$vs.loading.close(`#submitPermissionBtn > .con-vs-loading`)
          this.$gf.httpErrorHandler(error)
        })
    },

    generate_password(item, index) {
      this.user_generate = item.username
      this.user_generate_index = index
      this.password_duration = { label: '1 Hour', value: 1 }
      // this.$vs.dialog({
      //   type: 'confirm',
      //   color: 'warning',
      //   title: `Generate Password`,
      //   text: 'Are you sure want to Generate Password this User ?',
      //   accept: this.confirmGenerate
      // })
    },

    confirmGenerate() {
      this.$vs.loading({
        background: 'warning',
        color: '#fff',
        container: '#generateBtn_' + this.user_generate_index,
        scale: 0.45
      })

      this.$http
        .post(
          `${this.$api.portal_host}/user/generate_password`,
          {
            username: this.user_generate,
            client_ip: this.client_ip,
            password_duration: this.password_duration
              ? this.password_duration.value
              : 1
          },
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.pass_generate = res.data.password

          this.$vs.loading.close(
            `#generateBtn_${this.user_generate_index} > .con-vs-loading`
          )

          this.notify = res.data.message.split('_').join(' ')
          this.$vs.notify({
            title: 'Thank You',
            text: this.notify,
            color: 'success',
            position: 'top-right'
          })

          this.generatePopup = true
          this.generatePopupTitle = 'Generate Password'
        })
        .catch((error) => {
          this.$vs.loading.close(
            `#generateBtn_${this.user_generate_index} > .con-vs-loading`
          )

          this.$gf.httpErrorHandler(error)
        })
    },

    doCopyUsername() {
      let testingCodeToCopy = document.querySelector('#user_generate')
      testingCodeToCopy.setAttribute('type', 'text')
      testingCodeToCopy.select()

      try {
        var successful = document.execCommand('copy')
        var title = successful ? 'Thank You' : 'Sorry, failed'
        var text = successful
          ? 'Username copied successfully'
          : 'Username was not copied successfully'
        var color = successful ? 'success' : 'danger'

        this.$vs.notify({
          title: title,
          text: text,
          color: color,
          position: 'top-right'
        })
      } catch (err) {
        this.$vs.notify({
          title: 'Failed',
          text: 'Username was not copied successfully',
          color: 'danger',
          position: 'top-right'
        })
      }
    },

    doCopyPassword() {
      let testingCodeToCopy = document.querySelector('#pass_generate')
      testingCodeToCopy.setAttribute('type', 'text')
      testingCodeToCopy.select()

      try {
        var successful = document.execCommand('copy')
        var title = successful ? 'Thank You' : 'Sorry, failed'
        var text = successful
          ? 'Password copied successfully'
          : 'Password was not copied successfully'
        var color = successful ? 'success' : 'danger'

        this.$vs.notify({
          title: title,
          text: text,
          color: color,
          position: 'top-right'
        })
      } catch (err) {
        this.$vs.notify({
          title: 'Failed',
          text: 'Password was not copied successfully',
          color: 'danger',
          position: 'top-right'
        })
      }
    },

    getSalesList() {
      if (this.branch !== '') {
        this.$http
          .get(`${this.$api.endpoint}/sales/select/${this.branch}`, {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          })
          .then((res) => {
            this.salesList = res.data.message.data

            if (this.tempSales) {
              this.input.sales_id = this.salesList.find((item) => {
                return item.value === this.tempSales
              })
            }
          })
          .catch((error) => {
            this.$gf.httpErrorHandler(error)
          })
      }
    }
  }
}
</script>
